import { Box, Button, makeStyles, Typography } from '@material-ui/core';
// import SaveIcon from '@material-ui/icons/Save';
// import { equals } from 'ramda';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  systemDefaultFields: string[];
  systemDefaultPresets: ColumnPreset[];
  selectedColumns: string[];
  presetColumns: string[];
  onSaveSelectedAsPresetColumns: () => void;
  onActivatePreset: (ids: string[]) => void;
}

export interface ColumnPreset {
  label: string;
  fields: string[];
}

const ColumnPresets: React.FC<Props> = ({
  systemDefaultFields,
  systemDefaultPresets,
  // selectedColumns,
  // presetColumns,
  // onSaveSelectedAsPresetColumns,
  onActivatePreset,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Box className={classes.headerPanel}>
      <Typography>{t('app:datagrid:columnPreset:presets')}</Typography>
      <Box className={classes.buttons}>
        {systemDefaultPresets.map((p, index) => (
          <Button
            key={index}
            onClick={() => onActivatePreset(p.fields)}
            color="primary"
            variant="contained"
          >
            {p.label}
          </Button>
        ))}
        {/*<Typography>{t('app:datagrid:columnPreset:custom')}</Typography>*/}
        {/*<Box className={classes.button}>*/}
        {/*  <Button*/}
        {/*    onClick={() => onActivatePreset(presetColumns)}*/}
        {/*    color="primary"*/}
        {/*    variant="contained"*/}
        {/*    className={classes.customButtons}*/}
        {/*  >*/}
        {/*    <Typography>{t('app:datagrid:columnPreset:loadCustom')}</Typography>*/}
        {/*  </Button>*/}
        {/*  <Button*/}
        {/*    className={classes.customButtons}*/}
        {/*    onClick={onSaveSelectedAsPresetColumns}*/}
        {/*    disabled={equals([...presetColumns].sort(), [...selectedColumns].sort())}*/}
        {/*    color="primary"*/}
        {/*    variant="contained"*/}
        {/*  >*/}
        {/*    <SaveIcon />*/}
        {/*    <Typography>{t('app:datagrid:columnPreset:saveCustom')}</Typography>*/}
        {/*  </Button>*/}
        {/*</Box>*/}
        {/*<Typography>{t('app:datagrid:columnPreset:defaultPreset')}</Typography>*/}
        <Button
          onClick={() => onActivatePreset(systemDefaultFields)}
          color="primary"
          variant="contained"
        >
          {t('app:datagrid:columnPreset:resetToDefault')}
        </Button>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  headerPanel: {
    display: 'flex',
    flexWrap: 'wrap',
    overflow: 'hidden',
    color: theme.palette.text.primary,
    margin: theme.spacing(4),
  },
  buttons: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    '& button': {
      flex: 1,
      minWidth: '100px',
      margin: theme.spacing(1),
      padding: theme.spacing(2),
    },
  },
  customButtons: {
    display: 'flex',
    width: '49%',
  },
}));

export default ColumnPresets;
